export default {"src":"/_next/static/media/policy-and-procedure-review.9dcd027f.svg","height":348,"width":392,"blurWidth":0,"blurHeight":0};